// src/components/Whatsapp/index.jsx
import { Icon } from '@iconify/react'

export default function Whatsapp() {
    
    const whatsappStyle = {
        background: "#25D366",
        position: "fixed",
        right: "20px",
        bottom: "20px",
        borderRadius: "50%"
    }

  return (
    <a
      href="https://wa.me/923071753934" // Replace with your number
      target="_blank"
      rel="noopener noreferrer"
      style={whatsappStyle}
      className="whatsapp-icon fixed top-4 right-4 z-50 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-all"
    >
      <Icon icon="ic:baseline-whatsapp" width="36" height="36" />
    </a>
  )
}